import { render, staticRenderFns } from "./dictIndex.vue?vue&type=template&id=d0eabb30&scoped=true"
import script from "./dictIndex.vue?vue&type=script&lang=js"
export * from "./dictIndex.vue?vue&type=script&lang=js"
import style0 from "./dictIndex.vue?vue&type=style&index=0&id=d0eabb30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0eabb30",
  null
  
)

export default component.exports